import callAPI from "../callApi";
import path from "../variables";

const ReportSchedules = {
	getAll: () =>
		callAPI("GET", `${path.base}/report-schedules`, "", "getting report schedules"),
	create: (data: any) =>
		callAPI("POST", `${path.base}/report-schedules`, data, "creating report schedule"),
	update: (id: number, data: any) =>
		callAPI("PUT", `${path.base}/report-schedules/${id}`, data, "updating report schedule"),
	destroy: (id: number) =>
		callAPI("DELETE", `${path.base}/report-schedules/${id}`, "", "deleting report schedule"),
	sendNow: (id: number) =>
		callAPI("POST", `${path.base}/report-schedules/${id}/send-now`, {}, "sending report now"),
};

export default ReportSchedules;
